export class Feature {
    featureId : string;
    featureName : string;
    featureKey : string;
    }